import { Utils } from "@/plugins/utils"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		fn7: {},
		fn6: {},
		fn5: {},
		fn3: {},
		fn5doc: "",
		lstFn3: [],
		lstFn5: [],
		lstFn6: [],
		lstFn7: [],
		lstCv8: [],
		insert: false,
		update: false,
		loading: false,
		pending: false,
		search: "",
		lastUpdatedRegister: null,
		itemsPerPage: 200,
		sinceDate: moment().format("YYYY-MM-DD 00:00"),
		untilDate: moment().format("YYYY-MM-DD 23:59"),
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getInsert: state => {
			return state.insert
		},
		getFn5(state) {
			let fn5 = { ...state.fn5 }
			return fn5
		},
		getFn6(state) {
			let fn6 = { ...state.fn6 }
			return fn6
		},
		getFn7(state) {
			let fn7 = { ...state.fn7 }
			return fn7
		},
		getFn3(state) {
			let fn3 = { ...state.fn3 }
			return fn3
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, fn5) {
			state.fn5 = fn5
			if (fn5) state.update = true
		},
		setFn5Doc(state, fn5doc) {
			state.fn5doc = fn5doc
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.fn5 = null
			state.lstCv8 = []
			state.lstFn6 = []
		},
		setParamsDataTable(state, payload) {
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setFn5(state, fn5) {
			state.fn5 = fn5
		},
		setFn3(state, fn3) {
			state.fn3 = fn3
		},
		setFn6(state, fn6) {
			state.fn6 = fn6
		},
		setFn7(state, fn7) {
			state.fn7 = fn7
		},
		setLstFn5(state, lstFn5) {
			state.lstFn5 = lstFn5
		},
		setLstFn3(state, lstFn3) {
			state.lstFn3 = lstFn3
		},
		setLstFn6(state, lstFn6) {
			state.lstFn6 = lstFn6
		},
		setLstFn7(state, lstFn7) {
			state.lstFn7 = lstFn7
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async save({ getters, dispatch }, liquidModel) {
			if (getters.getUpdate) {
				return await dispatch("update", liquidModel)
			}
			return await dispatch("insert", liquidModel)
		},
		async insert({ commit, dispatch }, liquidModel) {

			let payload = await this._vm.$axios
				.post("/Financial/Liquidation/Insert", liquidModel)
				.then(response => {
					let reqData = Utils.ValidateAxiosResponse(response.data)
					commit("setLastUpdatedRegister", reqData)
					commit("setFn5", reqData)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async update({ commit, getters, dispatch }) {
			let payload = await this._vm.$axios
				.put("/Financial/Liquidation/Update", getters.getFn5)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},

		async saveFn6({ getters, dispatch }, fn6) {
			if (getters.getUpdate) {
				return await dispatch("updateFn6", fn6)
			}
			return await dispatch("insertFn6", fn6)
		},
		async insertFn6({ commit, dispatch }, fn6) {
			let payload = await this._vm.$axios
				.post("/Financial/LiquidationTitle/Insert", fn6)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async updateFn6({ commit, getters, dispatch }) {
			let payload = await this._vm.$axios
				.put("/Financial/LiquidationTitle/Update", getters.getFn6)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async deleteFn5({ dispatch }, fn5doc) {
			let payload = await this._vm.$axios
				.delete(`/Financial/Liquidation/Delete/${fn5doc}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async deleteFn6({ dispatch }, fn6) {
			let payload = await this._vm.$axios
				.delete(
					`/Financial/LiquidationTitle/Delete/${fn6.fn6emissor}/${fn6.fn6tipo}/${fn6.fn6docfis}/${fn6.fn6parcela}/${fn6.fn6doc}`,
					{
						headers: {
							"Content-Type": "application/json",
						},
					},
				)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async saveFn7({ getters, dispatch }, fn7) {
			if (fn7.update) {
				return await dispatch("updateFn7", fn7)
			}
			return await dispatch("insertFn7", fn7)
		},
		async insertFn7({ commit, dispatch }, fn7) {
			let payload = await this._vm.$axios
				.post("/Financial/LiquidationTitle/InsertFn7", fn7)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async searchFn7({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            let url = `/Financial/LiquidationTitle/SearchFn7?search=${getters.getSearch}&limit=${limit}&page=${page}`

            if (state.sinceDate) {
				url += `&since=${state.sinceDate}`
			}
			if (state.untilDate) {
				url += `&until=${state.untilDate}`
			} 
            let payload = await this._vm.$axios
				.get(url)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstFn7", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstFn7", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
		async findFn7({ commit, dispatch, state }, fn7) {
			commit("setLoading", true)
			await this._vm.$axios
				.get(`/Financial/LiquidationTitle/FindFn7?fn7doc=${fn7.fn7doc}&fn7emissor=${fn7.fn7emissor}&fn7tipo=${fn7.fn7tipo}&fn7docfis=${fn7.fn7docfis}&fn7parcela=${fn7.fn7parcela}&fn7conta=${fn7.fn7conta}`)
				.then(response => {
				let result = Utils.ValidateAxiosResponse(response.data)
				commit("setFn7", result)
				})
				.catch(error => {
				dispatch(
					"parameters/openDialog",
					{
					titleText: "Erro",
					titleColor: "red",
					text: error.message,
					},
					{ root: true },
				)
				})
			commit("setLoading", false)
		},
		async updateFn7({ commit, getters, dispatch }) {
			let payload = await this._vm.$axios
				.put("/Financial/LiquidationTitle/UpdateFn7", getters.getFn7)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async deleteFn7({ dispatch }, fn7) {
			await this._vm.$axios
				.delete(
					`/Financial/LiquidationTitle/DeleteFn7/${fn7.fn7doc}/${fn7.fn7emissor}/${fn7.fn7tipo}/${fn7.fn7docfis}/${fn7.fn7parcela}/${fn7.fn7conta}`,
					{
						headers: {
							"Content-Type": "application/json",
						},
					},
				)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
		},
		async findListFn3({ commit, dispatch }) {
			commit("setLoading", true)
			commit("initForm")

			try {
				const response = await this._vm.$axios.get("/Financial/LiquidationTitle/FindListFn3")
				const lstFn3 = Utils.ValidateAxiosResponse(response.data)

				commit("setLstFn3", lstFn3)
				commit("setLoading", false)
				return lstFn3

			} catch (error) {
				commit("setLstFn3", [])
				commit("setLoading", false)

				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)

				return []
			}
		},
		async printReportDetailedMovement(
			store,
			{
				fn5agenteSince = "",
				fn5agenteUntil = "",
				since,
				until,
				cv5clinomeSince = "",
				initialResult = false,
				receiveAvailable = false,
				incomeExpenses = false,
				clearanceAccessories = true,
				fn5docSince = "",
				fn5docUntil = "",
				snackbarBarOnError = false,
			},
		) {
			if (!since) since = moment().format("1899-12-31T00:00")
			if (!until) until = moment().format("9999-12-31T23:59")
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.post("/Financial/Liquidation/PrintReportDetailedMovement", {
					fn5agenteSince,
					fn5agenteUntil,
					since,
					until,
					cv5clinomeSince,
					initialResult,
					receiveAvailable,
					incomeExpenses,
					clearanceAccessories,
					fn5docSince,
					fn5docUntil,
				})
				.then(response => {
					let relatPath = Utils.ValidateAxiosResponse(response.data)
					if (relatPath) {
						store.dispatch("print/openRelatsPath", [relatPath], { root: true })
					}

					return true
				})
				.catch(error => {
					if (snackbarBarOnError) {
						store.dispatch(
							"parameters/showSnackBar",
							{
								show: true,
								timeout: 6000,
								text: error.message,
								color: "red",
							},
							{ root: true },
						)
					} else {
						store.dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: error.message,
							},
							{ root: true },
						)
					}
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async saveBankCheckDeposit({ commit, dispatch }, lstFn9) {
			let payload = await this._vm.$axios
				.post("/Financial/Liquidation/saveBankCheckDeposit", lstFn9)
				.then(response => {
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
	},
}
